// Copy this file and register its import in ../registry.js. Inactive by default.
export default {
  id: 'example',
  application: 'bayhive',
  productName: 'Example Auto',
  colors: {
    light: {
      primary: '#006699',
      success: '#26733d',
      danger: '#b62020',
      warn: '#ffcc00',
      surface: '#ffffff',
      text: '#212529',
      mutedText: '#495057',
    },
    dark: {
      primary: '#75c9f0',
      success: '#78d691',
      danger: '#ffa0a0',
      warn: '#ffdc66',
      surface: '#181c23',
      text: '#f7f8fa',
      mutedText: '#c9cdd4',
    },
  },
  fontFamily: 'Arial, sans-serif',
  radius: { control: '0.2rem', surface: '0.25rem', dialog: '0.3rem' },
  // Add logos: { light, dark, iconLight, iconDark } using imported asset URLs.
  // Without custom assets the product name is shown instead of a BayHive logo.
  logos: {},
  pdf: {
    accent: '#006699',
    text: '#212529',
    muted: '#495057',
    body: '#343a40',
    header: '#f8f9fa',
    border: '#dee2e6',
    rowBorder: '#e9ecef',
  },
};
